import request from '@/utils/request';

// 应用列表
export function getCommodityList(params) {
  return request({
    url: '/poseidon/commodity/merchantCommodityList',
    method: 'get',
    params: params,
  });
}

// 查询商品详情，根据商品code
export function getCommodityByCommodityCode(params) {
  return request({
    url: '/poseidon/commodity/queryCommodityByCommodityCode',
    method: 'get',
    params: params,
  });
}

// 创建订单
export function createAppOrder(data) {
  return request({
    url: '/poseidon/order/createOrder',
    method: 'post',
    data,
  });
}

// 查询正在支付的订单
export function getPayOrderByOrderNo(params) {
  return request({
    url: '/poseidon/order/queryOrderDetailByOrderNo',
    method: 'get',
    params: params,
  });
}

// 返回支付二维码
export function getPayCode(params) {
  return request({
    url: '/poseidon/order/payOrder',
    method: 'get',
    params: params,
  });
}

// 返回支付状态
export function getPayStatus(params) {
  return request({
    url: '/poseidon/order/queryPayStatus',
    method: 'get',
    params: params,
  });
}

// 调用关单接口
export function closePayOrder(params) {
  return request({
    url: '/poseidon/order/closePayOrder',
    method: 'get',
    params: params,
  });
}

// 获取商城产品列表
export function queryMerchantOrderList(params) {
  return request({
    url: '/poseidon/order/queryMerchantOrderList',
    method: 'get',
    params: params,
  });
}

// 根据酒店code查询所有商品
export function queryCommodityByHotelCode(params) {
  return request({
    url: '/poseidon/commodity/queryCommodityByHotelCode',
    method: 'get',
    params: params,
  });
}

//导出
export function exportMerchantAllOrderList(params) {
  return request({
    url: '/poseidon/order/exportMerchantAllOrderList',
    method: 'get',
    params: params,
  });
}
